import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { DefaultsContext } from '../../../DefaultsContext'
import { useGetRichPlacementMultiAnchor } from '../../hooks/useGetRichPlacementMultiAnchor'
import { useUpdateRichPlacementMultiAnchor } from '../../hooks/useUpdateRichPlacementMultiAnchor'
import { schema, Schema, schemaDefault } from './schema'
import { MultiAnchorSection } from './Section'

export const MultiAnchorForm = (): JSX.Element => {
  const { formId, setTouched, setValid } = useContext(DefaultsContext)
  const { isLoading: isFetching, multiAnchor } = useGetRichPlacementMultiAnchor()

  const { errors, isPending: isUpdating, update } = useUpdateRichPlacementMultiAnchor()

  if (!multiAnchor) {
    return <Loading />
  }

  return (
    <Form<Schema>
      externalErrors={errors}
      id={formId}
      loading={isFetching || isUpdating}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(multiAnchor)}
    >
      {() => <MultiAnchorSection />}
    </Form>
  )
}
